import AboutBrand from "./AboutBrand";

export default AboutBrand;
